import { z } from 'zod';

export const zodBulkDismissParsingCasesPayloadSchema = z.object({
  caseIds: z.array(z.uuid()).min(1).max(100),
  reason: z.string().nullish(),
});

const zodBulkDismissSuccessResultSchema = z.object({
  caseId: z.uuid(),
  dismissedOn: z.iso.datetime({ offset: true }),
  status: z.literal('DISMISSED'),
  success: z.literal(true),
});

const zodBulkDismissFailureResultSchema = z.object({
  caseId: z.uuid(),
  errorCode: z.string().nullish(),
  errorDetail: z.string().nullish(),
  success: z.literal(false),
});

// fallow-ignore-next-line unused-export
export const zodBulkDismissResultSchema = z.discriminatedUnion('success', [
  zodBulkDismissSuccessResultSchema,
  zodBulkDismissFailureResultSchema,
]);

export const zodBulkDismissParsingCasesResponseSchema = z.object({
  data: z.array(zodBulkDismissResultSchema),
  failed: z.number().int().nonnegative(),
  requested: z.number().int().nonnegative(),
  succeeded: z.number().int().nonnegative(),
});
